import {Component, DestroyRef, inject, input, OnInit, signal} from '@angular/core';
import {CurrentService} from "@/app/api/current.service";
import {Current} from "@models/sportexam";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector   : 'app-user-badge',
    imports    : [],
    templateUrl: './user-badge.component.html',
    styleUrl   : './user-badge.component.scss'
})
export class UserBadgeComponent implements OnInit {
    state = input<'regular' | 'extended'>('extended')
    loading = signal(false);
    user = signal<string>('')
    destroyRef = inject(DestroyRef)

    constructor(
        private currentService: CurrentService
    )
    {
    }

    ngOnInit() {
        this.loading.set(true);
        if (this.state() == 'extended') {
            this.currentService.current
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((v: Current) => {
                this.user.set(v?.data?.fio);
                this.loading.set(false);
            })
        } else {
            this.loading.set(false);
        }
    }
}
